/** @format */

import React, { ChangeEvent, useCallback, useEffect, useState } from 'react';
import GridContainer from '../../../components/Grid/GridContainer';
import GridItem from '../../../components/Grid/GridItem';
import { SimpleSelect, SimpleSelectElements } from '../../../components/Adescom/SimpleSelect';
import PlatformResellerInterface from '../../../interfaces/platform/PlatformResellerInterface';
import { REQUEST_STATE } from '../../../helpers/RequestHelper';
import { PlatformResellerSendType } from '../PlatformResellerModify';
import CustomMultiSelect from '../../../components/Form/CustomMultiSelect';
import { ItemLoaders } from '../../../core/loaders/ItemLoaders';
import { FormGeneralHelper } from '../../../helpers/FormGeneral';
import { configDefault } from '../../../core/config';
import { SYSTEM_LANGUAGE_ACTIONS } from '../../../modules/language/actions';
import { SystemLanguageCollectionInterface } from '../../../modules/language/interfaces/SystemLanguageInterface';
import { useDispatch } from 'react-redux';
import { SystemCurrencyCollectionInterface, SystemCurrencyInterface } from '../../../modules/currency/interfaces/SystemCurrencyInterface';
import Loader from '../../../components/Loaders/Loader';
import CircularProgress from '@material-ui/core/CircularProgress';
import CountryCodeInterface from '../../../interfaces/platform/CountryCodeInterface';
import { CountryCodeCollectionInterface } from '../../../interfaces/collections/CountryCodeCollectionInterface';

interface PlatformResellerCurrencyPropsInterface {
    platformResellerId: string | null | undefined;
    platformReseller: PlatformResellerInterface | PlatformResellerSendType;
    changeCurrencyCallback: (event: React.ChangeEvent<HTMLSelectElement>) => void;
}

const PlatformResellerCurrency: React.FC<PlatformResellerCurrencyPropsInterface> = (props) => {
    const { platformReseller, platformResellerId } = props;
    const dispatch = useDispatch();

    const [currencies, setCurrencies] = useState<Array<SystemCurrencyInterface>>([]);
    const [loadingFinished, setLoadingFinished] = useState<boolean>(false);

    const loadItemsPage = useCallback(
        (specificPage: string | null) => {
            const itemLoader = new ItemLoaders(dispatch);
            const defaultUri = FormGeneralHelper.getPath('/system_currencies', configDefault.PLATFORM_API_PREFIX);
            itemLoader.getListWithCallback(
                FormGeneralHelper.getByUri(specificPage ? specificPage : defaultUri),
                SYSTEM_LANGUAGE_ACTIONS.LIST,
                [
                    {
                        name: 'itemsPerPage',
                        value: 100,
                    },
                ],
                [
                    {
                        name: 'renderOrder',
                        value: 'ASC',
                    },
                ],
                {
                    onSuccess: (data: SystemCurrencyCollectionInterface) => {
                        setCurrencies((currencies) => (currencies ? [...currencies, ...data['hydra:member']] : data['hydra:member']));

                        if ('hydra:next' in data['hydra:view']) {
                            loadItemsPage(data['hydra:view']['hydra:next']);
                        } else {
                            setLoadingFinished(true);
                        }
                    },
                    onError: (error: any) => {
                        console.log(error);
                        setLoadingFinished(true);
                    },
                },
                { propagateDataToCallback: true, dispatchAfterCallback: false }
            );
        },
        [dispatch]
    );

    useEffect(() => {
        loadItemsPage(null);
    }, [loadItemsPage]);

    const saveCallback = (event: React.ChangeEvent<HTMLSelectElement>): void => {
        props.changeCurrencyCallback(event);
    };

    return (
        <>
            {loadingFinished && currencies && (
                <SimpleSelect
                    label={'platform_reseller:pr.reseller_currency'}
                    required={true}
                    elements={currencies.map((el) => {
                        return {
                            name: `${el.currencyName} (${el.currencySign})`,
                            value: el.id,
                        } as SimpleSelectElements;
                    })}
                    dispatchName={'currency'}
                    fieldName={'currency'}
                    selectedValue={platformReseller.currencyId}
                    callback={saveCallback}
                />
            )}
            {!loadingFinished && <CircularProgress />}
        </>
    );
};

export default PlatformResellerCurrency;
